import React from 'react'
import {
  Row,
  Col,
  FormControl,
  FormGroup,
  Checkbox,
  Modal,
  Button as BSButton
} from 'react-bootstrap'
import { Link } from 'react-router'
import moment from 'moment'
import i18next from 'i18next'
import { List } from 'immutable'
import classnames from 'classnames'
import queryString from 'query-string'

import LanguageSelectorFormControl from './LanguageSelectorFormControl'
import WopiListProfile from './WopiListProfile'
import WopiListInvitation from './WopiListInvitation'
import Paginator from './Paginator'
import Notificator from './Notificator'
import SupportFileDownload from './SupportFileDownload'
import Loading from './Loading'
import supportService from '../services/support'
import GridContainer from './GridContainer'
import NoWopiResults from './NoWopiResults'
import Button from './Button'
import DocumentLink from './DocumentLink'
import BottomBarListSelection from './BottomBarListSelection'

import buttonStyles from './styles/button.scss'
import listingStyles from './styles/listing.scss'
import searchIcon from './../assets/images/search.png'

const makeBottomBarUrl = (currentOrganisationId, language, selectedUUIDs, wellBeingProfile) => {
  const params = {
    uuid: selectedUUIDs.toJS()
  }

  params.wellbeing = wellBeingProfile ? 1 : undefined

  return `/api/organisations/${currentOrganisationId}/profiles/wopi/${language}?${queryString.stringify(
    params
  )}`
}

export default class WopiList extends React.Component {
  constructor(props) {
    super(props)

    // TODO: Move to global state?
    this.state = {
      keyword: '',
      selectedUUIDs: List(),
      language: props.currentLanguage,
      wellBeingProfile: false,
      activeModalLink: null,
      deleteModalOpen: null,
      supportFileGroups: []
    }
  }

  componentDidMount() {
    this.props.search(
      this.props.currentOrganisationId,
      null,
      {},
      1,
      this.props.showOnlyOwnQuestionnaires
    )

    supportService.getFileGroups(['experts_in_work_guide', 'analysis_pages']).then(response => {
      this.setState({ supportFileGroups: response.data })
    })
  }

  handleDeleteModalOpen = uuid => e => {
    e.preventDefault()

    this.setState({
      deleteModalOpen: uuid
    })
  }

  handleDeleteModalClose = () => {
    this.setState({
      deleteModalOpen: null
    })
  }

  handleInvitationWopisModalClose = () => this.props.setNewInvitationWopis()

  clearSelections = () => {
    this.setState({ selectedUUIDs: List() })
  }

  render() {
    const {
      questionnaires,
      searchFilters,
      pagination,
      sentInvitations,
      showOnlyOwnQuestionnaires,
      currentOrganisationId,
      currentLanguage,
      newInvitationWopis
    } = this.props

    const { deleteModalOpen } = this.state

    moment.locale(currentLanguage)

    const openList = searchFilters.status === 'open'
    const closedList = !openList

    return (
      <GridContainer>
        <div style={{ marginBottom: 365 }}>
          <Modal show={deleteModalOpen !== null} onHide={this.handleDeleteModalClose}>
            <Modal.Header closeButton>
              <Modal.Title>{i18next.t('delete_wopi_title')}</Modal.Title>
            </Modal.Header>

            <Modal.Body style={{ borderRadius: 6 }}>
              <p>{i18next.t('delete_wopi_description')}</p>

              <Button
                text={i18next.t('delete_wopi')}
                onClick={this.handleDelete(deleteModalOpen)}
              />
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.activeModalLink !== null}
            onHide={() => this.setState({ activeModalLink: null })}
          >
            <Modal.Header closeButton>
              <Modal.Title>{i18next.t('link_to_questionnaire')}</Modal.Title>
            </Modal.Header>

            {this.state.activeModalLink && (
              <Modal.Body>
                {this.state.activeModalLink.email && (
                  <p>
                    {i18next.t('questionnaire_link_description_sent_to')}&nbsp;
                    <strong>{this.state.activeModalLink.email}</strong>.
                  </p>
                )}

                {!this.state.activeModalLink.email && (
                  <p>{i18next.t('questionnaire_link_created')}</p>
                )}

                <pre style={{ marginBottom: 20 }}>
                  {window.location.protocol}//{window.location.host}/wopi/{
                    this.state.activeModalLink.uuid
                  }
                </pre>

                <Button
                  text={i18next.t('close')}
                  onClick={() => this.setState({ activeModalLink: null })}
                />
              </Modal.Body>
            )}
          </Modal>

          <Modal show={newInvitationWopis.size > 0} onHide={this.handleInvitationWopisModalClose}>
            <Modal.Header closeButton>
              <Modal.Title>{i18next.t('links_generated')}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Row>
                <Col md={12}>
                  <Notificator type="success">
                    <header>{i18next.t('links_generated_successfully')}</header>
                  </Notificator>
                </Col>
              </Row>

              <p>{i18next.t('links_generated_explanation')}</p>

              <div style={{ marginBottom: 20 }}>
                {newInvitationWopis.map(wopi => (
                  <pre key={wopi.uuid} style={{ marginBottom: 5 }}>
                    {window.location.protocol}//{window.location.host}/wopi/{wopi.uuid}
                  </pre>
                ))}
              </div>

              <Button text={i18next.t('close')} onClick={this.handleInvitationWopisModalClose} />
            </Modal.Body>
          </Modal>

          <Row>
            <Col md={12}>
              {sentInvitations.count() > 0 && (
                <Notificator type="success">
                  <header>{i18next.t('invitation_emails_sent')}</header>

                  <p>
                    {i18next.t('invitations_sent_to')} <i>{sentInvitations.join(', ')}</i>
                  </p>
                </Notificator>
              )}
            </Col>
          </Row>

          <Row>
            <Col md={6} lg={8}>
              <header>
                <h1>{i18next.t('questionnaires')}</h1>

                <Link
                  id="new-wopi-link"
                  to="/new-test"
                  className={buttonStyles.button}
                  style={{ marginLeft: 20 }}
                >
                  {i18next.t('new_questionnaire')}
                </Link>
              </header>
            </Col>

            <Col md={6} lg={4}>
              <div className={listingStyles.extraLinks}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    gap: 12
                  }}
                >
                  {this.state.supportFileGroups.map((group, idx) => (
                    <SupportFileDownload
                      key={group.groupKey}
                      label={
                        group.labelTranslationKey
                          ? i18next.t(group.labelTranslationKey)
                          : group.labels[this.state.language] || group.labels['en'] || ''
                      }
                      files={group.files}
                    />
                  ))}
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={12} className={listingStyles.filters}>
              <Row>
                <Col md={8} style={{ marginBottom: 15 }}>
                  <a
                    href="#"
                    onClick={this.handleSearchWithFilters({})}
                    className={classnames({
                      [listingStyles.active]: closedList
                    })}
                  >
                    {i18next.t('wopi_results')}
                  </a>

                  <a
                    id="open-assessments"
                    href="#"
                    onClick={this.handleSearchWithFilters({ status: 'open' })}
                    className={classnames({
                      [listingStyles.active]: openList
                    })}
                  >
                    {i18next.t('open_invitations')}
                  </a>

                  <label>
                    <input
                      type="checkbox"
                      onClick={this.onToggleShowOnlyOwnQuestionnaires.bind(this)}
                      defaultChecked={showOnlyOwnQuestionnaires}
                    />
                    <span>{i18next.t('show_only_own')}</span>
                  </label>
                </Col>

                <Col md={4}>
                  <form onSubmit={this.handleSearch} style={{ position: 'relative' }}>
                    <FormControl
                      type="text"
                      className={listingStyles.search}
                      placeholder={i18next.t('search_for_questionnaires')}
                      value={this.state.keyword}
                      onChange={this.onChangeKeyword.bind(this)}
                    />
                    <BSButton className={listingStyles.searchIcon} onClick={this.handleSearch}>
                      <img src={searchIcon} />
                    </BSButton>
                  </form>
                </Col>
              </Row>
            </Col>
          </Row>

          <Loading inline={true} isReady={questionnaires}>
            {questionnaires && (
              <div>
                {questionnaires.count() === 0 && (
                  <NoWopiResults
                    translationKey={
                      searchFilters.status == 'open'
                        ? 'invitations_will_be_listed_here'
                        : 'questionnaires_will_be_listed_here'
                    }
                  />
                )}

                {questionnaires.count() > 0 && (
                  <div className="table-responsive">
                    <table className="table table-hover">
                      {this.renderHeaderElement(searchFilters)}

                      <tbody>
                        {questionnaires.map((q, key) =>
                          this.renderRowElement(
                            q,
                            key,
                            searchFilters,
                            this.state.language,
                            this.state.selectedUUIDs,
                            currentOrganisationId
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                )}

                {pagination && (
                  <Paginator
                    totalCount={pagination.totalCount}
                    page={pagination.page}
                    limit={pagination.limit}
                    onPaginate={page =>
                      this.props.search(
                        this.props.currentOrganisationId,
                        this.state.keyword,
                        searchFilters,
                        page,
                        showOnlyOwnQuestionnaires
                      )
                    }
                  />
                )}
              </div>
            )}
          </Loading>

          <BottomBarListSelection
            isVisible={!this.state.selectedUUIDs.isEmpty()}
            selectedCount={this.state.selectedUUIDs.size}
            onDeselect={this.clearSelections}
          >
            <a
              className={buttonStyles.button}
              href={makeBottomBarUrl(
                this.props.currentOrganisationId,
                this.state.language,
                this.state.selectedUUIDs,
                this.state.wellBeingProfile
              )}
            >
              {i18next.t('download')}
            </a>
          </BottomBarListSelection>
        </div>
      </GridContainer>
    )
  }

  toggleSelection(uuid) {
    const existingIndex = this.state.selectedUUIDs.indexOf(uuid)

    if (existingIndex !== -1) {
      return this.setState({ selectedUUIDs: this.state.selectedUUIDs.delete(existingIndex) })
    }

    this.setState({ selectedUUIDs: this.state.selectedUUIDs.push(uuid) })
  }

  renderHeaderElement(filters) {
    if (filters.status === 'open') {
      return (
        <thead>
          <tr>
            <th style={{ width: 140 }}>{i18next.t('date')}</th>
            <th>{i18next.t('email_address')}</th>
            <th>{i18next.t('organisation')}</th>
            <th>{i18next.t('role')}</th>
            <th>{i18next.t('actions')}</th>
          </tr>
        </thead>
      )
    }

    return (
      <thead>
        <tr>
          <th style={{ textAlign: 'center', width: 80 }}>{i18next.t('select')}</th>
          <th style={{ width: 140 }}>{i18next.t('date')}</th>
          <th>{i18next.t('respondent')}</th>
          <th>{i18next.t('organisation_and_role')}</th>
          <th>{i18next.t('duration')}</th>
          <th style={{ minWidth: 310, textAlign: 'right' }}>
            <FormGroup
              bsSize="sm"
              className={classnames('form-inline', listingStyles.profileExtrasForm)}
            >
              <Checkbox
                name="wellbeing"
                onClick={e => this.setState({ wellBeingProfile: e.target.checked })}
              >
                {i18next.t('work_wellbeing_profile')}
              </Checkbox>

              <LanguageSelectorFormControl
                onChange={e => this.setState({ language: e.target.value })}
                defaultValue={this.state.language}
                withoutFormGroup={true}
                showOnlyAdminLanguages={false}
                shouldTranslateLanguages={true}
              />
            </FormGroup>
          </th>
        </tr>
      </thead>
    )
  }

  renderRowElement(
    questionnaire,
    key,
    filters,
    currentLanguage,
    selectedUUIDs,
    currentOrganisationId
  ) {
    const isDeleted = this.props.deletedWopis.contains(questionnaire.uuid)

    if (filters.status === 'open') {
      const onView = () => {
        this.setState({
          activeModalLink: { uuid: questionnaire.uuid, email: questionnaire.invitation.email }
        })

        return false
      }

      return (
        <WopiListInvitation
          key={key}
          questionnaire={questionnaire}
          isDeleted={isDeleted}
          onDelete={this.handleDeleteModalOpen(questionnaire.uuid)}
          onView={onView}
        />
      )
    }

    return (
      <WopiListProfile
        key={key}
        questionnaire={questionnaire}
        isDeleted={isDeleted}
        isSelected={selectedUUIDs.contains(questionnaire.uuid)}
        onToggleSelection={() => this.toggleSelection(questionnaire.uuid)}
      >
        <span className={listingStyles.downloadLink}>
          {!isDeleted && (
            <DocumentLink
              href={`/api/organisations/${currentOrganisationId}/profiles/wopi/${
                questionnaire.uuid
              }/${currentLanguage}${this.state.wellBeingProfile ? '?wellbeing=1' : ''}`}
              text={i18next.t('download_pdf')}
            />
          )}

          {!isDeleted && (
            <small style={{ marginLeft: 30 }}>
              <a href="#" onClick={this.handleDeleteModalOpen(questionnaire.uuid)}>
                {i18next.t('delete')}
              </a>
            </small>
          )}

          {isDeleted && <span>{i18next.t('deleted')}</span>}
        </span>
      </WopiListProfile>
    )
  }

  onChangeKeyword(e) {
    this.setState({ keyword: e.target.value })
  }

  handleSearch = e => {
    e.preventDefault()

    const { search, currentOrganisationId, searchFilters, showOnlyOwnQuestionnaires } = this.props

    search(currentOrganisationId, this.state.keyword, searchFilters, 1, showOnlyOwnQuestionnaires)
  }

  handleSearchWithFilters = searchFilters => e => {
    e.preventDefault()

    const { search, currentOrganisationId, showOnlyOwnQuestionnaires } = this.props

    search(currentOrganisationId, this.state.keyword, searchFilters, 1, showOnlyOwnQuestionnaires)
  }

  handleDelete = uuid => () => {
    this.props.deleteWopi(this.props.currentOrganisationId, uuid)

    this.setState({
      deleteModalOpen: null
    })
  }

  onToggleShowOnlyOwnQuestionnaires(e) {
    const showOwn = !this.props.showOnlyOwnQuestionnaires

    this.props.setShowOnlyOwnQuestionnaires(showOwn)

    this.props.search(
      this.props.currentOrganisationId,
      this.state.keyword,
      this.props.searchFilters,
      1,
      showOwn
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WopiList.js